module.exports = __webpack_public_path__ + "img/sigmagaming.1cf589bd.svg";